import { isMobile } from '@/utils/isMobile'

/**
 *  Panel state module file
**/

export const state = {
  isMobile: isMobile(),
  layerTree: [],
  bbox: undefined,
  initialBbox: [[ -18.984375, 27.137368359795584 ], [ 5.44921875, 44.68427737181225 ]],
  blockBbox: false,
  coordinates: undefined,
  zoom: 19,
  accessToken: undefined,
  cartografyTiles: [],
  config: {
    id: undefined,
    airport: undefined,
    explorerMode: false,
    building: undefined,
    floor: undefined,
    category: undefined,
    language: undefined,
    poi: undefined,
    poiD: undefined,
    route: undefined,
    printMode: false,
    lat: undefined,
    lon: undefined,
    mupiMode: false,
    zonaubicacion: undefined
  },
  airport: {
    bbox: undefined,
    iata_code: undefined,
    icao_code: undefined,
    name: undefined,
    has_graph: false,
    pois_version_date: undefined
  },
  buildings: [],
  building: undefined,
  floor: undefined,
  activeFilters: {
    categories: null,
    subcategories: [],
    building: undefined,
    search: undefined
  },
  poisCatalog: [],
  poisList: {
    features: [],
    type: undefined
  },
  uncategorizedPoisList: {
    features: [],
    type: undefined
  },
  transitionPoisList: [],
  poi: undefined,
  pointGrouped: [],
  routeMode: false,
  route: {
    destinationName: 'origin',
    steps: [],
    duration: 0,
    distance: 0,
    z: 0,
    route: [],
    loading: false,
    error: undefined,
    defaultLevelBuilding: {}
  },
  routeCount: 0,
  show_pmr_config: false,
  pmr_profile: null,
  view: undefined,
  feedback: false,
  deviceWidth: window.innerWidth,
  homePosition: undefined,
  filtering: undefined
}
